/* exported SubscriptionManagerV3IAPI */
/* eslint-disable block-scoped-var */
/* eslint-disable no-prototype-builtins */

/*One Subscription Manager per application, for each componenet within application create a controller*/
//settings = settings.currentlyLoggedIn, settings.settings.refreshRatesConfiguration
// eslint-disable-next-line no-unused-vars
class SubscriptionManagerV3IAPI {

    static SubscriptionManagerV3IAPI = function (managerOptions) {

        var ModeTypes = {
            Exchange: 1,
            Multiples: 2,
            Sportsbook: 3
        };

        const utils = managerOptions.utils;

        var gep = {
            convertor: function (item1, item2) {
                var i;
                /* eslint-disable guard-for-in */
                for (i in item1) {
                    item2[i] = item1[i];
                }
                /* eslint-enable guard-for-in */
                if ((item1 instanceof gec.MarketDetail) && (item2 instanceof gec.SubscribedExchangeMarket)) {
                    item2.status = item1.marketStatusId;
                    item2.canBeInRunning = item1.willBeInRunning;
                    item2.name = item1.marketName;
                    item2.displayOrder = item1.displayOrder;
                    item2.delayFactor = item1.inRunningDelaySeconds;
                    item2.marketType = item1.marketType;

                    return item2;
                }

                if ((item1 instanceof gec.SelectionDetail) && (item2 instanceof gec.SubscribedExchangeSelection)) {
                    item2.status = item1.selectionStatusId;
                    item2.canBeInRunning = item1.willBeInRunning;
                    item2.name = item1.selectionName;
                    if (!item2.marketId) {
                        item2.marketId = (item1.getMarket() ? item1.getMarket().marketId : item2.marketId);
                    }


                    item2.backPrices = [];

                    /* eslint-disable guard-for-in */
                    for (i in item1.forExchangePrices) {
                        item2.backPrices.push({ displayPrice: item1.forExchangePrices[i].displayPrice, stake: item1.forExchangePrices[i].amountAvailable });
                    }
                    item2.layPrices = [];

                    for (i in item1.againstExchangePrices) {
                        item2.layPrices.push({ displayPrice: item1.againstExchangePrices[i].displayPrice, stake: item1.againstExchangePrices[i].amountAvailable });
                    }
                    /* eslint-enable guard-for-in */

                    return item2;
                }

                return null;
            }
        };

        // Returns an array of ids from array of objects
        function toPropArray(ar, prop) {
            var newAr = [];
            for (var i = 0; i < ar.length; i++) {
                newAr[i] = ar[i][prop];
            }

            return newAr;
        }

        function calculateSportsBookIntervalTime(market) {

            var now = new Date(),
                startTime = new Date(market.startTime),
                diff = startTime - now;

            if (diff < 3600000) { //Less than 1 hour to event start time - 10 secs
                return 10 * 1000;
            } else if ((diff >= 3600000) && (diff < 86400000)) { //Less than 24 hours to event start time - 30 secs
                return 30 * 1000;
            } else { //More than 24 hours to event start time - 120 secs
                return 120 * 1000;
            }
        }

        function createUUID() {
            // Function found here: https://gist.github.com/jed/982883
            /*eslint no-bitwise:  ["error", { "allow": ["^", ">>"] }]*/
            var a = "";
            function b(c) {
                // Need to create variables x and y to keep JSLint happy
                var x = (c ^ (Math.random() * 16)) >> (c / 4);
                var y = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
                return c
                    ? (x).toString(16)
                    : (y).replace(/[018]/g, b);
            }
            return b(a);
        }

        // data accessible to each Controller
        var markets = {},
            eventClassifiers = {},
            selections = {},
            matchedAmounts = {},
            prices = {},
            sportsbookPrices = {},
            indexedMarketSelections = {};

        //function compareMarkets(existingObject, newObject, changes) {

        //    var hasChanges = false;
        //    var properties = [
        //        "marketId",
        //        "eventClassifierId",
        //        "eventClassifierFullName",
        //        "grandparentEventClassifierId",
        //        "marketName",
        //        "name",
        //        "description",
        //        "isEnabledForMultipleBets",
        //        "selectionIconsURL",
        //        "iconWidth",
        //        "iconHeight",
        //        "marketType",
        //        "isPlayMarket",
        //        "placePayout",
        //        "willBeInRunning",
        //        "managedWhenInRunning",
        //        "inRunningDelaySeconds",
        //        "totalMatchedAmount",
        //        "isCurrentlyInRunning",
        //        "numberOfWinningSelections",
        //        "startTime",
        //        "suspendTime",
        //        "status",
        //        "marketStatusId", //This needs to be fixed in GEC - KL to raise bug
        //        "withdrawalSequenceNumber",
        //        "isEnabledForEachWayBetting"];

        //    //check market completed and dont overwrite the other properties.
        //    var propertyName = "marketStatusId";
        //    if ((existingObject["marketStatusId"] !== newObject["marketStatusId"] && (newObject["marketStatusId"] === 4))
        //        || (existingObject["status"] !== newObject["status"] && (newObject["status"] === 4))) {

        //        existingObject[propertyName] = newObject[propertyName];
        //        if (newObject["status"] !== undefined) {
        //            existingObject["status"] = newObject["status"];
        //            changes["status"] = newObject["status"];
        //        }
        //        if (newObject["marketStatusId"] !== undefined) {
        //            existingObject["marketStatusId"] = newObject["marketStatusId"];
        //            changes["marketStatusId"] = newObject["marketStatusId"];
        //        }

        //        hasChanges = true;
        //    } else {
        //        // eslint-disable-next-line no-shadow
        //        $.each(properties, function (ignore, propertyName) {
        //            if (existingObject[propertyName] !== newObject[propertyName]) {
        //                changes[propertyName] = newObject[propertyName];
        //                existingObject[propertyName] = newObject[propertyName];
        //                hasChanges = true;
        //            }
        //        });
        //    }

        //    return hasChanges;
        //}

        //Controller for eventCard, homepage, betslip etc.
        this.Controller = function (controllerOptions) {
            var currentMarketIdsForInformation = {},
                currentMarketIdsForPrices = {},
                currentMarketIdsForSportsbookPrices = {},
                currentMarketIdsForMatchedAmounts = {},
                currentSelectionIdsForPrices = {},
                currentIndividualMarkets = {};
            //used to know what this controller subscribed to so can unsubscribe


            var cachedMarketAttributes = {};
            var sportsBookInterval;
            var subscribedIds = {};
            var subscriptionId = 1;
            var subscriptionIdMappedToMarketIds = {};

            var getAttributesRefreshRate = 5000;
            var marketAttributesRefreshId;


            var currentSubscriptionParams;

            var iapiPriceIntervalID = null;
            var individualPriceIntervalID = null;
            var currentPriceInterval = 5000;
            var currentIndividualPriceInterval = 5000;

            controllerOptions.minimumIntervaltime = controllerOptions.minimumIntervaltime || 0;


            this.startSubscriptions = function (subscriptionParams) {

                var gecMarketInformationCall = managerOptions.clientMode === ModeTypes.Sportsbook ? managerOptions.gecController.getSportsbookPrices : managerOptions.gecController.getExchangePrices;

                var uuid = createUUID();
                subscribedIds[uuid] = [];
                var firstRequest = true;
                var sportsbookIntervalTime;

                if (subscriptionParams.marketIdsForSportsbookPrices !== undefined && subscriptionParams.marketIdsForSportsbookPrices.length > 0) {
                    subscriptionParams.marketIdsForSportsbookPrices.forEach(function (marketId) {
                        currentMarketIdsForSportsbookPrices[marketId] = true;
                    });

                    if (sportsBookInterval !== undefined) {
                        window.clearInterval(sportsBookInterval);
                    }

                    // eslint-disable-next-line no-inner-declarations
                    function getSportsBookPrices(marketIds) {

                        var sportsbookRequest = {
                            marketIds: marketIds,
                            wantIcons: true,
                            wantSelectionBlurb: firstRequest,
                            callbackOnSuccess: function (sportsPricesResp) {
                                if (firstRequest) {
                                    subscriptionIdMappedToMarketIds[subscriptionId] = marketIds;
                                    //subscribedIds[uuid].push(subscriptionId);
                                    subscriptionId++;
                                }
                                if (sportsPricesResp && sportsPricesResp.length) {
                                    var currentIntervalTime = calculateSportsBookIntervalTime(sportsPricesResp[0]);
                                    //callculate newSportsbookInterval and if different clear interval and start new one
                                    if (sportsbookIntervalTime != currentIntervalTime) {
                                        window.clearInterval(sportsBookInterval);
                                        sportsbookIntervalTime = currentIntervalTime;
                                        sportsBookInterval = window.setInterval(function () {
                                            getSportsBookPrices(marketIds);
                                        }, sportsbookIntervalTime);

                                    }

                                    //loop through prices and fire events
                                    var marketI, selectionI, thisMarket, thisSelection;

                                    /* eslint-disable guard-for-in */
                                    for (marketI in sportsPricesResp) {
                                        thisMarket = sportsPricesResp[marketI];
                                        var hasMarketChange = false;

                                        thisMarket.status = thisMarket.marketStatusId;

                                        if (markets[thisMarket.marketId] === undefined) {
                                            hasMarketChange = true;

                                            indexSelections(thisMarket);

                                            markets[thisMarket.marketId] = new GBEMarket(thisMarket);
                                        } else {
                                            var newMarketStatus = thisMarket.marketStatusId;
                                            var existingMarketstatus = markets[thisMarket.marketId].marketStatusId || markets[thisMarket.marketId].status;

                                            if (newMarketStatus !== existingMarketstatus) {
                                                hasMarketChange = true;
                                                markets[thisMarket.marketId].status = newMarketStatus;
                                                markets[thisMarket.marketId].marketStatusId = newMarketStatus;


                                            }
                                        }

                                        if (hasMarketChange) {
                                            if (controllerOptions.onMarketChange !== undefined) {
                                                controllerOptions.onMarketChange({
                                                    newObject: thisMarket
                                                });

                                            }
                                        }

                                        for (selectionI in thisMarket.selections) {
                                            /* eslint-enable guard-for-in */
                                            thisSelection = thisMarket.selections[selectionI];

                                            var sportsSelections = managerOptions.sportsSelections || managerOptions.sportsSeletions; // backward compatibility
                                            sportsSelections[thisSelection.selectionId] = new GBESelection(thisSelection);

                                            // eslint-disable-next-line
                                            thisSelection.displayOrder = (selectionI * 1) + 1;
                                            thisSelection.marketId = thisSelection.market.marketId;
                                            thisSelection.name = thisSelection.selectionName;
                                            thisSelection.status = thisSelection.selectionStatusId;
                                            thisSelection.selectionIcon = thisSelection.market.selectionIconsURL;

                                            if (controllerOptions.onSelectionChange !== undefined) {
                                                selections[thisSelection.selectionId] = new GBESelection(thisSelection);
                                                controllerOptions.onSelectionChange({ changes: undefined, newObject: thisSelection });
                                            }
                                            if (controllerOptions.onSportsbookPriceChange !== undefined) {

                                                sportsbookPrices[thisSelection.selectionId] = {
                                                    selectionId: thisSelection.selectionId,
                                                    decimalPrice: thisSelection.forSportsbookPrices.price,
                                                    backReferencePrice: thisSelection.forSportsbookPrices.backReferencePrice || "",
                                                    marketId: thisMarket.marketId
                                                };

                                                controllerOptions.onSportsbookPriceChange({
                                                    newObject: sportsbookPrices[thisSelection.selectionId]
                                                });
                                            }

                                        }
                                    }

                                } else {
                                    window.clearInterval(sportsBookInterval);

                                    //wipe prices from event card as market completed
                                }

                            },
                            callbackOnException: function () {
                                console.error("error calling getSportsbookPrices");
                            }

                        };
                        managerOptions.gecController.getSportsbookPrices(sportsbookRequest);
                    }

                    getSportsBookPrices(subscriptionParams.marketIdsForSportsbookPrices);
                }

                subscriptionParams.marketIdsForInformation?.forEach(function (marketId) {
                    currentMarketIdsForInformation[marketId] = true;
                });

                subscriptionParams.marketIdsForMatchedAmounts?.forEach(function (marketId) {
                    currentMarketIdsForMatchedAmounts[marketId] = true;
                });

                if (subscriptionParams.marketIdsForInformation && subscriptionParams.marketIdsForInformation.length > 0) {
                    if (marketAttributesRefreshId !== undefined) {
                        window.clearInterval(marketAttributesRefreshId);
                    }
                    marketAttributesRefreshId = window.setInterval(function () {
                        managerOptions.gecController.getMarketAttributes({
                            marketIds: subscriptionParams.marketIdsForInformation,
                            attributes: [1, 2, 3, 5],
                            currency: controllerOptions.currency,
                            // eslint-disable-next-line no-shadow
                            callbackOnSuccess: function (markets) {
                                //compare objects to see whats changed
                                markets?.forEach(function (thisMarket) {
                                    var hasChanges = false;
                                    var hasMatchedamountchange = false;

                                    currentMarketIdsForInformation[thisMarket.marketId] = true;

                                    cachedMarketAttributes[thisMarket.marketId] = cachedMarketAttributes[thisMarket.marketId] || {};
                                    var cachedAttributes = cachedMarketAttributes[thisMarket.marketId];
                                    cachedAttributes.marketId = thisMarket.marketId;

                                    var changes;

                                    if (thisMarket.attributes) {
                                        changes = { marketId: thisMarket.marketId };
                                        // eslint-disable-next-line no-shadow
                                        thisMarket.attributes?.forEach(function (attribute) {
                                            var attributeName = "";
                                            var attributeValue;
                                            switch (attribute.attribute) {
                                                case 1://Status
                                                    attributeName = "status";
                                                    // eslint-disable-next-line no-implicit-coercion
                                                    attributeValue = attribute.value * 1;
                                                    if (cachedAttributes[attributeName] != attributeValue) {
                                                        hasChanges = true;
                                                    }
                                                    break;
                                                case 2://MatchedAmount
                                                    attributeName = "totalMatchedAmount";
                                                    // eslint-disable-next-line no-implicit-coercion
                                                    attributeValue = attribute.value * 1;
                                                    if (cachedAttributes[attributeName] != attributeValue) {
                                                        hasMatchedamountchange = true;
                                                        cachedAttributes.forSideAmount = attributeValue;
                                                        cachedAttributes.againstSideAmount = 0;
                                                        changes.forSideAmount = attributeValue;
                                                        changes.againstSideAmount = 0;
                                                    }
                                                    break;
                                                case 3://isCurrentlyInRunning
                                                    attributeName = "isCurrentlyInRunning";
                                                    attributeValue = (attribute.value === "True");
                                                    if (cachedAttributes[attributeName] != attributeValue) {
                                                        hasChanges = true;
                                                    }
                                                    break;
                                                case 4://WithdrawalSequenceNumber
                                                    attributeName = "withdrawalSequenceNumber";
                                                    // eslint-disable-next-line no-implicit-coercion
                                                    attributeValue = attribute.value * 1;
                                                    if (cachedAttributes[attributeName] != attributeValue) {
                                                        hasChanges = true;
                                                    }
                                                    break;
                                                case 5://StartTime
                                                    attributeName = "startTime";
                                                    attributeValue = attribute.value;
                                                    if (cachedAttributes[attributeName] != attributeValue) {
                                                        hasChanges = true;
                                                    }
                                                    break;
                                            }

                                            if (cachedAttributes[attributeName] != attributeValue) {
                                                changes[attributeName] = attributeValue;
                                                cachedAttributes[attributeName] = attributeValue;
                                            }
                                        });
                                    }
                                    if (hasMatchedamountchange) {
                                        if (controllerOptions.onMatchedAmountChange !== undefined) {
                                            var newmarket = changes;
                                            newmarket.marketId = thisMarket.marketId;

                                            controllerOptions.onMatchedAmountChange({ changes: changes, iapiMarket: true, newObject: newmarket });
                                        }
                                    }

                                    if (hasChanges) {
                                        if (controllerOptions.onMarketAttributeChange !== undefined) {
                                            // eslint-disable-next-line no-redeclare
                                            var newmarket = changes;
                                            newmarket.marketId = thisMarket.marketId;
                                            controllerOptions.onMarketAttributeChange({ changes: changes, iapiMarket: true, newObject: newmarket });//used undefined market as we may not have it
                                        }
                                    }


                                });


                                if (subscriptionParams && subscriptionParams.callbackOnSuccess) {
                                    subscriptionIdMappedToMarketIds[subscriptionId] = subscriptionParams.marketIdsForInformation;
                                    // subscribedIds[uuid].push(subscriptionId);
                                    subscriptionId++;
                                    subscriptionParams.callbackOnSuccess(subscribedIds);
                                    delete subscriptionParams.callbackOnSuccess;
                                }
                            },
                            callbackOnException: function () {
                                // eslint-disable-next-line no-undef
                                setAttributesRefreshTimout();
                            }

                        });

                    },
                    getAttributesRefreshRate
                    );

                }

                currentSubscriptionParams = subscriptionParams;

                if (subscriptionParams.marketIdsForPrices === undefined && subscriptionParams.selectionIds === undefined) {
                    return;
                }
                var request = {
                    marketIds: subscriptionParams.marketIdsForPrices,
                    selectionIds: subscriptionParams.selectionIds,
                    markets: undefined,
                    eventClassifierId: undefined,
                    eventClassifier: undefined,
                    marketTypeId: undefined,
                    playMarkets: false,
                    wantIcons: false,
                    justRefreshPrices: false,
                    maxNoOfSelectionsToReturn: subscriptionParams.maxNoOfSelectionsToReturn,
                    thresholdAmount: managerOptions.preferences.marketByVolumeAmount || 1,
                    numberForPricesRequired: subscriptionParams.numberForSidePrices || 3,
                    numberAgainstPricesRequired: subscriptionParams.numberAgainstSidePrices || 3,
                    // eslint-disable-next-line no-shadow
                    callbackOnSuccess: function (markets) {
                        if (firstRequest) {
                            subscriptionIdMappedToMarketIds[subscriptionId] = subscriptionParams.marketIdsForPrices;
                            // subscribedIds[uuid].push(subscriptionId);
                            subscriptionId++;
                        }
                        if (subscriptionParams.marketIdsForInformation) {
                            if (markets.length != subscriptionParams.marketIdsForInformation.length) {
                                //missing markets so find complete markets
                                var incomingMarketIds = toPropArray(markets, "marketId");
                                var missingMarketIds = [];
                                for (var i = 0; i < subscriptionParams.marketIdsForInformation.length; i++) {
                                    if (!incomingMarketIds?.includes(subscriptionParams.marketIdsForInformation[i])) {
                                        missingMarketIds.push(subscriptionParams.marketIdsForInformation[i]);
                                        delete currentMarketIdsForInformation[subscriptionParams.marketIdsForInformation[i]];

                                        console.log("delte a market");
                                    }
                                }

                            }
                        }

                        processIAPIResponse(markets, subscriptionParams, firstRequest);
                        var newRefreshRate = utils.getRefreshRate(markets, managerOptions.settings.currentlyLoggedIn, managerOptions.settings.refreshRatesConfiguration);

                        if (firstRequest || (newRefreshRate != currentPriceInterval)) {

                            currentPriceInterval = utils.getRefreshRate(markets, managerOptions.settings.currentlyLoggedIn, managerOptions.settings.refreshRatesConfiguration);
                            firstRequest = false;

                            window.clearInterval(iapiPriceIntervalID);
                            iapiPriceIntervalID = window.setInterval(function () {

                                //managerOptions.gecController.getExchangePrices(request);
                                gecMarketInformationCall.call(managerOptions.gecController, request);

                            }, Math.max(currentPriceInterval, controllerOptions.minimumIntervaltime));
                        }

                    },
                    callbackOnException: function () {
                        window.clearInterval(iapiPriceIntervalID);
                        console.error("error calling getSportsbookPrices");
                    }
                };
                //managerOptions.gecController.getExchangePrices(request);
                gecMarketInformationCall.call(managerOptions.gecController, request);


            };

            //called after a connection reconnect or when the punter priceForamt/marketBy Volume changed
            this.restartMarketSubscription = function () {

                if (currentSubscriptionParams !== undefined) {
                    var tempParams = {
                        eventClassifierId: null,
                        marketIdsForInformation: utils.toArrayFromIndex(currentMarketIdsForPrices),
                        marketIdsForMatchedAmounts: utils.toArrayFromIndex(currentMarketIdsForMatchedAmounts),
                        numberAgainstSidePrices: currentSubscriptionParams.numberAgainstSidePrices,
                        numberForSidePrices: currentSubscriptionParams.numberForSidePrices
                    };
                    tempParams = currentSubscriptionParams;

                    currentSubscriptionParams = null;
                    currentMarketIdsForInformation = {};
                    currentMarketIdsForPrices = {};
                    currentMarketIdsForMatchedAmounts = {};

                    this.startSubscriptions(tempParams);

                }
            };

            var individualMarketsRefreshInterval;
            this.addMarketSubscription = function (params) {
                // eslint-disable-next-line no-shadow
                var firstIndividualRequest = true;

                params.marketIds?.forEach(function (marketId) {
                    currentIndividualMarkets[marketId] = true;
                });

                currentIndividualMarkets[params.marketId] = true;

                var marketIds = [];
                for (var marketId in currentIndividualMarkets) {
                    if (currentIndividualMarkets.hasOwnProperty(marketId)) {
                        marketIds.push(marketId);
                    }
                }

                if (individualMarketsRefreshInterval !== undefined) {
                    window.clearInterval(individualMarketsRefreshInterval);
                }

                if (marketIds.length === 0) {
                    params.callbackOnSuccess();
                    return;
                }
                params.numberForSidePrices = params.numberForSidePrices || 1;
                params.numberAgainstSidePrices = params.numberAgainstSidePrices || 1;


                var request;
                var sportsbookIntervalTime;

                if (params.wantSportsbookPrices) {
                    request = {
                        marketIds: params.marketIds,
                        wantIcons: true,
                        wantSelectionBlurb: firstIndividualRequest,
                        callbackOnSuccess: function (sportsPricesResp) {
                            processIndividualIAPIResponse(sportsPricesResp, params, firstIndividualRequest);
                            if (sportsPricesResp && sportsPricesResp.length) {
                                var currentIntervalTime = calculateSportsBookIntervalTime(sportsPricesResp[0]);
                                //callculate newSportsbookInterval and if different clear interval and start new one
                                if (sportsbookIntervalTime != currentIntervalTime) {
                                    window.clearInterval(sportsBookInterval);
                                    sportsbookIntervalTime = currentIntervalTime;
                                    sportsBookInterval = window.setInterval(function () {
                                        managerOptions.gecController.getSportsbookPrices(request);
                                    }, sportsbookIntervalTime);

                                }

                                //loop through prices and fire events
                                var marketI, selectionI, thisMarket, thisSelection;

                                /* eslint-disable guard-for-in */
                                for (marketI in sportsPricesResp) {
                                    thisMarket = sportsPricesResp[marketI];


                                    if (controllerOptions.onMarketChange !== undefined) {
                                        controllerOptions.onMarketChange({
                                            newObject: thisMarket
                                        });

                                    }
                                    for (selectionI in thisMarket.selections) {
                                        /* eslint-enable guard-for-in */
                                        thisSelection = thisMarket.selections[selectionI];
                                        var sportsSelections = managerOptions.sportsSelections || managerOptions.sportsSeletions;// backward compatibility
                                        sportsSelections[thisSelection.selectionId] = new GBESelection(thisSelection);

                                        if (controllerOptions.onSportsbookPriceChange !== undefined) {

                                            sportsbookPrices[thisSelection.selectionId] = {
                                                selectionId: thisSelection.selectionId,
                                                decimalPrice: thisSelection.forSportsbookPrices.price,
                                                backReferencePrice: thisSelection.forSportsbookPrices.backReferencePrice || "",
                                                marketId: thisMarket.marketId
                                            };

                                            controllerOptions.onSportsbookPriceChange({
                                                newObject: sportsbookPrices[thisSelection.selectionId]
                                            });
                                        }

                                    }
                                }

                            }
                        },
                        callbackOnException: function (sportsPricesResp) {
                            console.error("getSportsbookPrices:" + sportsPricesResp);
                        }
                    };

                    managerOptions.gecController.getSportsbookPrices(request);
                } else {
                    request = {
                        marketIds: params.marketIds,
                        selectionIds: params.selectionIds,
                        markets: undefined,
                        eventClassifierId: undefined,
                        eventClassifier: undefined,
                        marketTypeId: undefined,
                        playMarkets: false,
                        wantIcons: false,
                        justRefreshPrices: false,
                        maxNoOfSelectionsToReturn: params.maxNoOfSelectionsToReturn,
                        thresholdAmount: managerOptions.preferences.marketByVolumeAmount || 1,
                        numberForPricesRequired: params.numberForSidePrices,
                        numberAgainstPricesRequired: params.numberAgainstSidePrices,
                        callbackOnSuccess: function (responseMarkets) {
                            processIndividualIAPIResponse(responseMarkets, params, firstIndividualRequest);

                            var combinedMarketIds = [];

                            for (var marketId2 in currentIndividualMarkets) {
                                if (currentIndividualMarkets.hasOwnProperty(marketId2)) {
                                    combinedMarketIds.push(marketId2);
                                }
                            }

                            request.marketIds = combinedMarketIds;


                            var newRefreshRate = utils.getRefreshRate(markets, managerOptions.settings.currentlyLoggedIn, managerOptions.settings.refreshRatesConfiguration);

                            if (firstIndividualRequest || (newRefreshRate !== currentIndividualPriceInterval)) {

                                currentIndividualPriceInterval = utils.getRefreshRate(markets, managerOptions.settings.currentlyLoggedIn, managerOptions.settings.refreshRatesConfiguration);
                                firstIndividualRequest = false;

                                window.clearInterval(iapiPriceIntervalID);
                                iapiPriceIntervalID = window.setInterval(function () {

                                    managerOptions.gecController.getExchangePrices(request);

                                }, Math.max(currentIndividualPriceInterval, controllerOptions.minimumIntervaltime));
                            }
                            params.callbackOnSuccess();
                        },
                        callbackOnException: function (response) {
                            console.error("GetExchangePrices - Individual Markets" + response.returnCode);
                        }
                    };
                    managerOptions.gecController.getExchangePrices(request);
                }


            };

            this.removeMarketSubscription = function (params) {

                delete currentIndividualMarkets[params.marketId];
                params.callbackOnSuccess();
            };

            //unubscribe everthing for this controller
            this.unloadUI = function (params) {

                //eventClassifiers = {};
                //markets = {};
                //selections = {};
                //prices = {};
                //matchedAmounts = {};

                //loop through currentMarketIdsForPrices, currentMarketIdsForInformation, currentMarketIdsForMatchedAmounts
                //and market these ....lopp through the other controllers so you know what to keep and then delete this ones markets, selects, prices etc.

                currentMarketIdsForInformation = {};
                currentMarketIdsForPrices = {};
                currentMarketIdsForSportsbookPrices = {};
                currentMarketIdsForMatchedAmounts = {};
                subscribedIds = {};
                subscriptionIdMappedToMarketIds = {};

                window.clearInterval(iapiPriceIntervalID);
                window.clearInterval(individualPriceIntervalID);

                if (marketAttributesRefreshId !== undefined) {
                    window.clearInterval(marketAttributesRefreshId);
                }

                params.callbackOnSuccess?.call(this);

            };
            var processIAPIResponse = function (responseMarkets, subscriptionParams, firstRequest) {

                for (var m = 0; m < responseMarkets.length; m++) {

                    var isNewMarket = false;
                    var isMarketChange = false;

                    indexSelections(responseMarkets[m]);

                    var newMarket = new GBEMarket(responseMarkets[m], m + 1);

                    if (markets[responseMarkets[m].marketId] == null) {
                        isNewMarket = true;
                        isMarketChange = true;

                        markets[newMarket.marketId] = newMarket;

                        //fire new marketEvent
                        if (controllerOptions.onMarketChange != null) {
                            controllerOptions.onMarketChange({ changes: null, iapiMarket: true, newObject: markets[responseMarkets[m].marketId] });
                        }

                        //fire new matchedAmountEvent
                        if (controllerOptions.onMatchedAmountChange != null) {
                            if (controllerOptions.onMatchedAmountChange != null) {
                                controllerOptions.onMatchedAmountChange({
                                    newObject: {
                                        marketId: responseMarkets[m].marketId,
                                        forSideAmount: responseMarkets[m].totalMatchedAmount,
                                        againstSideAmount: 0
                                    }
                                });
                            }
                        }

                    } else {

                        if (isNewMarket || (markets[responseMarkets[m].marketId].totalMatchedAmount != responseMarkets[m].totalMatchedAmount)) {
                            //fire update matchedAmountEvent
                            if (controllerOptions.onMatchedAmountChange != null) {
                                controllerOptions.onMatchedAmountChange({
                                    newObject: {
                                        marketId: responseMarkets[m].marketId,
                                        forSideAmount: responseMarkets[m].totalMatchedAmount,
                                        againstSideAmount: 0
                                    }
                                });
                            }
                        }

                        var changes = {};
                        var isChange = false;
                        if (markets[newMarket.marketId].status != newMarket.status) {
                            changes.status = newMarket.status;
                            isChange = true;
                        }
                        if (newMarket.status !== 4) {
                            if (markets[newMarket.marketId].isCurrentlyInRunning != newMarket.isCurrentlyInRunning) {
                                changes.isCurrentlyInRunning = newMarket.isCurrentlyInRunning;
                                isChange = true;
                            }
                            if (markets[newMarket.marketId].canBeInRunning != newMarket.willBeInRunning) {
                                changes.canBeInRunning = newMarket.canBeInRunning;
                                isChange = true;
                            }
                            if (markets[newMarket.marketId].name != newMarket.marketName) {
                                changes.name = newMarket.name;
                                isChange = true;
                            }
                            if (markets[newMarket.marketId].startTime != newMarket.startTime) {
                                changes.startTime = newMarket.startTime;
                                isChange = true;
                            }
                        }

                        if (!isChange) {
                            changes = undefined;
                        }

                        if (newMarket.status !== 4) {
                            markets[newMarket.marketId] = new GBEMarket(newMarket, m + 1);
                        } else {
                            markets[newMarket.marketId].status = newMarket.status;
                        }

                        if (isChange) {
                            isMarketChange = true;
                        }

                        //fire update marketEvent check for changes

                        // eslint-disable-next-line no-mixed-operators
                        if (firstRequest || isMarketChange && (controllerOptions.onMarketChange != null)) {
                            controllerOptions.onMarketChange({ changes: changes, iapiMarket: true, newObject: markets[responseMarkets[m].marketId] });
                        }
                    }

                    var marketSelections = getMarketSelections(responseMarkets[m].marketId);

                    for (var s = 0; s < marketSelections.length; s++) {
                        var isSelectionChange = false;
                        var newSelection = marketSelections[s];


                        if (newMarket === undefined) {
                            console.error(newSelection);
                        }
                        if (newSelection === undefined) {
                            console.error(newMarket);
                        }
                        newSelection.marketId = newMarket.marketId;
                        newSelection.status = newSelection.selectionStatusId;
                        newSelection.name = newSelection.selectionName;
                        newSelection.displayOrder = s + 1;

                        managerOptions.selections[newSelection.selectionId] = new GBESelection(newSelection);


                        var isPriceChange = false;

                        if (firstRequest || prices[newSelection.selectionId] == null) {

                            if (managerOptions.clientMode === ModeTypes.Sportsbook) {
                                prices[newSelection.selectionId] = { item: { selectionId: newSelection.selectionId, marketId: newMarket.marketId, backReferencePrice: newSelection.forSportsbookPrices.backReferencePrice } };
                            } else {
                                prices[newSelection.selectionId] = { item: { selectionId: newSelection.selectionId, marketId: newMarket.marketId, backPrices: [], layPrices: [] } };
                            }

                            isPriceChange = true;
                        }
                        if (managerOptions.clientMode !== ModeTypes.Sportsbook) {
                            for (var f = 0; f < subscriptionParams.numberForSidePrices; f++) {

                                newSelection.forExchangePrices[f] = newSelection.forExchangePrices[f] || { displayPrice: "", amountAvailable: 0, stake: 0 };

                                prices[newSelection.selectionId].item.backPrices[f] = prices[newSelection.selectionId].item.backPrices[f] || { displayPrice: "", amountAvailable: 0, stake: 0 };
                                // eslint-disable-next-line max-depth
                                if ((prices[newSelection.selectionId].item.backPrices[f].displayPrice != newSelection.forExchangePrices[f].displayPrice) || (prices[newSelection.selectionId].item.backPrices[f].stake != newSelection.forExchangePrices[f].amountAvailable)) {
                                    isPriceChange = true;
                                }

                                prices[newSelection.selectionId].item.backPrices[f].stake = newSelection.forExchangePrices[f].amountAvailable;
                                prices[newSelection.selectionId].item.backPrices[f].displayPrice = newSelection.forExchangePrices[f].displayPrice;
                            }

                            newSelection.backPrices = prices[newSelection.selectionId].item.backPrices;

                            // eslint-disable-next-line no-redeclare
                            for (var f = 0; f < subscriptionParams.numberAgainstSidePrices; f++) {

                                newSelection.againstExchangePrices[f] = newSelection.againstExchangePrices[f] || { displayPrice: "", amountAvailable: 0, stake: 0 };

                                prices[newSelection.selectionId].item.layPrices[f] = prices[newSelection.selectionId].item.layPrices[f] || { displayPrice: "", amountAvailable: 0, stake: 0 };
                                // eslint-disable-next-line max-depth
                                if ((prices[newSelection.selectionId].item.layPrices[f].displayPrice != newSelection.againstExchangePrices[f].displayPrice) || (prices[newSelection.selectionId].item.layPrices[f].stake != newSelection.againstExchangePrices[f].amountAvailable)) {
                                    isPriceChange = true;
                                }

                                prices[newSelection.selectionId].item.layPrices[f].stake = newSelection.againstExchangePrices[f].amountAvailable;
                                prices[newSelection.selectionId].item.layPrices[f].displayPrice = newSelection.againstExchangePrices[f].displayPrice;

                            }
                            newSelection.layPrices = prices[newSelection.selectionId].item.layPrices;

                        }

                        if (firstRequest || selections[marketSelections[s].selectionId] == null) {
                            isSelectionChange = true;
                            changes = null;

                        } else {
                            changes = {};
                            if (selections[marketSelections[s].selectionId].status != newSelection.status) {
                                isSelectionChange = true;
                                selections[marketSelections[s].selectionId].status = newSelection.status;
                                changes.status = selections[marketSelections[s].selectionId].status;
                            }

                            if (selections[marketSelections[s].selectionId].displayOrder != newSelection.displayOrder) {
                                isSelectionChange = true;
                                selections[marketSelections[s].selectionId].displayOrder = newSelection.displayOrder;
                                changes.displayOrder = selections[marketSelections[s].selectionId].displayOrder;

                            }

                            if (selections[marketSelections[s].selectionId].name != newSelection.name) {
                                isSelectionChange = true;
                                // eslint-disable-next-line no-unused-expressions
                                selections[marketSelections[s].selectionId].name != newSelection.name;
                                changes.name = selections[marketSelections[s].selectionId].name;
                            }
                        }

                        selections[marketSelections[s].selectionId] = marketSelections[s];

                        if (isSelectionChange && (controllerOptions.onSelectionChange != null)) {
                            selections[newSelection.selectionId] = new GBESelection(newSelection);
                            controllerOptions.onSelectionChange({ changes: changes, newObject: newSelection });
                        }

                        if (isPriceChange) {

                            if (managerOptions.clientMode !== ModeTypes.Sportsbook && controllerOptions.onPriceChange != null) {
                                controllerOptions.onPriceChange({ newObject: prices[newSelection.selectionId].item });
                            }
                            if (managerOptions.clientMode === ModeTypes.Sportsbook && controllerOptions.onSportsbookPriceChange != null) {
                                controllerOptions.onSportsbookPriceChange({ newObject: prices[newSelection.selectionId].item });
                            }
                        }

                    } //end selections

                } //end markets
            };

            // eslint-disable-next-line no-unused-vars, no-shadow
            var processIndividualIAPIResponse = function (responseMarkets, subscriptionParams) {

                for (var m = 0; m < responseMarkets.length; m++) {

                    var isNewMarket = false;
                    var isMarketChange = false;

                    var newMarket = new gec.SubscribedExchangeMarket();

                    responseMarkets[m].displayOrder = m + 1;
                    gep.convertor(responseMarkets[m], newMarket);

                    if (markets[responseMarkets[m].marketId] == null) {
                        isNewMarket = true;
                        isMarketChange = true;
                        //markets[market.marketId] = { item: newMarket, delegate: id };

                        markets[newMarket.marketId] = new GBEMarket(newMarket, m + 1);

                        //fire new marketEvent
                        if (controllerOptions.onMarketChange != null) {
                            controllerOptions.onMarketChange({ changes: null, iapiMarket: true, newObject: markets[responseMarkets[m].marketId] });
                        }

                        //fire new matchedAmountEvent
                        if (controllerOptions.onMatchedAmountChange != null) {
                            if (controllerOptions.onMatchedAmountChange != null) {
                                controllerOptions.onMatchedAmountChange({
                                    newObject: {
                                        marketId: responseMarkets[m].marketId,
                                        forSideAmount: responseMarkets[m].totalMatchedAmount,
                                        againstSideAmount: 0
                                    }
                                });
                            }
                        }

                    } else {

                        if (isNewMarket || (markets[responseMarkets[m].marketId].totalMatchedAmount != responseMarkets[m].totalMatchedAmount)) {
                            //fire update matchedAmountEvent
                            if (controllerOptions.onMatchedAmountChange != null) {
                                controllerOptions.onMatchedAmountChange({
                                    newObject: {
                                        marketId: responseMarkets[m].marketId,
                                        forSideAmount: responseMarkets[m].totalMatchedAmount,
                                        againstSideAmount: 0
                                    }
                                });
                            }
                        }

                        var changes = {};
                        var isChange = false;
                        if (markets[newMarket.marketId].status != newMarket.status) {
                            changes.status = newMarket.status;
                            isChange = true;
                        }
                        if (newMarket.status !== 4) {
                            if (markets[newMarket.marketId].isCurrentlyInRunning != newMarket.isCurrentlyInRunning) {
                                changes.isCurrentlyInRunning = newMarket.isCurrentlyInRunning;
                                isChange = true;
                            }
                            if (markets[newMarket.marketId].canBeInRunning != newMarket.willBeInRunning) {
                                changes.canBeInRunning = newMarket.canBeInRunning;
                                isChange = true;
                            }
                            if (markets[newMarket.marketId].name != newMarket.marketName) {
                                changes.name = newMarket.name;
                                isChange = true;
                            }
                            if (markets[newMarket.marketId].startTime != newMarket.startTime) {
                                changes.startTime = newMarket.startTime;
                                isChange = true;
                            }
                        }

                        if (newMarket.status !== 4) {
                            markets[newMarket.marketId] = new GBEMarket(newMarket, m + 1);
                        } else {
                            markets[newMarket.marketId].status = newMarket.status;
                        }

                        if (isChange) {
                            isMarketChange = true;
                        }

                        //fire update marketEvent check for changes

                        if (isMarketChange && (controllerOptions.onMarketChange != null)) {
                            controllerOptions.onMarketChange({ changes: changes, iapiMarket: true, newObject: markets[responseMarkets[m].marketId] });

                        }
                    }

                    var marketSelections = getMarketSelections(responseMarkets[m].marketId);

                    for (var s = 0; s < marketSelections.length; s++) {
                        var isSelectionChange = false;
                        var newSelection = marketSelections[s];


                        if (newMarket === undefined) {
                            console.error(newSelection);
                        }
                        if (newSelection === undefined) {
                            console.error(newMarket);
                        }
                        newSelection.marketId = newMarket.marketId;
                        newSelection.status = newSelection.selectionStatusId;
                        newSelection.name = newSelection.selectionName;
                        newSelection.displayOrder = s + 1;

                        managerOptions.selections[newSelection.selectionId] = new GBESelection(newSelection);


                        var isPriceChange = true;

                        if (prices[newSelection.selectionId] == null) {
                            prices[newSelection.selectionId] = { item: { selectionId: newSelection.selectionId, marketId: newMarket.marketId, backPrices: [], layPrices: [] } };
                            isPriceChange = true;
                        }

                        for (var f = 0; f < subscriptionParams.numberForSidePrices; f++) {

                            if (newSelection.forExchangePrices[f] == null) {
                                newSelection.forExchangePrices[f] = { displayPrice: "", amountAvailable: 0, stake: 0 };
                            }

                            if (prices[newSelection.selectionId].item.backPrices[f] == null) {
                                prices[newSelection.selectionId].item.backPrices[f] = { displayPrice: "", amountAvailable: 0, stake: 0 };
                            }

                            if ((prices[newSelection.selectionId].item.backPrices[f].displayPrice != newSelection.forExchangePrices[f].displayPrice) || (prices[newSelection.selectionId].item.backPrices[f].stake != newSelection.forExchangePrices[f].amountAvailable)) {
                                isPriceChange = true;
                            }

                            prices[newSelection.selectionId].item.backPrices[f].stake = newSelection.forExchangePrices[f].amountAvailable;
                            prices[newSelection.selectionId].item.backPrices[f].displayPrice = newSelection.forExchangePrices[f].displayPrice;
                        }

                        newSelection.backPrices = prices[newSelection.selectionId].item.backPrices;

                        // eslint-disable-next-line no-redeclare
                        for (var f = 0; f < subscriptionParams.numberAgainstSidePrices; f++) {

                            if (newSelection.againstExchangePrices[f] == null) {
                                newSelection.againstExchangePrices[f] = { displayPrice: "", amountAvailable: 0, stake: 0 };
                            }

                            if (prices[newSelection.selectionId].item.layPrices[f] == null) {
                                prices[newSelection.selectionId].item.layPrices[f] = { displayPrice: "", amountAvailable: 0, stake: 0 };
                            }

                            if ((prices[newSelection.selectionId].item.layPrices[f].displayPrice != newSelection.againstExchangePrices[f].displayPrice) || (prices[newSelection.selectionId].item.layPrices[f].stake != newSelection.againstExchangePrices[f].amountAvailable)) {
                                isPriceChange = true;
                            }

                            prices[newSelection.selectionId].item.layPrices[f].stake = newSelection.againstExchangePrices[f].amountAvailable;
                            prices[newSelection.selectionId].item.layPrices[f].displayPrice = newSelection.againstExchangePrices[f].displayPrice;

                        }
                        newSelection.layPrices = prices[newSelection.selectionId].item.layPrices;

                        // clientObject.selections[newSelection.selectionId] = newSelection;


                        if (selections[marketSelections[s].selectionId] == null) {
                            isSelectionChange = true;
                            changes = null;

                        } else {
                            changes = {};
                            if (selections[marketSelections[s].selectionId].status != newSelection.status) {
                                isSelectionChange = true;
                                selections[marketSelections[s].selectionId].status = newSelection.status;
                                changes.status = selections[marketSelections[s].selectionId].status;
                            }

                            if (selections[marketSelections[s].selectionId].displayOrder != newSelection.displayOrder) {
                                isSelectionChange = true;
                                selections[marketSelections[s].selectionId].displayOrder = newSelection.displayOrder;
                                changes.displayOrder = selections[marketSelections[s].selectionId].displayOrder;

                            }

                            if (selections[marketSelections[s].selectionId].name != newSelection.name) {
                                isSelectionChange = true;
                                // eslint-disable-next-line no-unused-expressions
                                selections[marketSelections[s].selectionId].name != newSelection.name;
                                changes.name = selections[marketSelections[s].selectionId].name;
                            }

                        }

                        selections[marketSelections[s].selectionId] = marketSelections[s];

                        if (isSelectionChange && (controllerOptions.onSelectionChange != null)) {

                            selections[newSelection.selectionId] = new GBESelection(newSelection);
                            controllerOptions.onSelectionChange({ changes: changes, newObject: newSelection });
                        }

                        if (isPriceChange && (controllerOptions.onPriceChange != null)) {
                            controllerOptions.onPriceChange({ newObject: prices[newSelection.selectionId].item });
                        }

                    } //end selections

                } //end markets
            };
            this.getPrice = function (selId) {
                if (prices[selId] !== undefined) {
                    return prices[selId].item || { backPrices: [], layPrices: [] };
                } else {
                    return { backPrices: [], layPrices: [] };
                }

            };
            this.addMarket = function (market) {
                markets[market.marketId] = market;
            };
            this.getSportsbookPrice = function (selId) {
                return sportsbookPrices[selId] || { "selectionId": selId, "price": "" };
            };

            this.getState = function () {
                return {
                    marketIdsForInformation: currentMarketIdsForInformation,
                    marketIdsForPrices: currentMarketIdsForPrices,
                    marketIdsForMatchedAmounts: currentMarketIdsForMatchedAmounts,
                    selectionIdsForPrices: currentSelectionIdsForPrices,
                    individualMarkets: currentIndividualMarkets
                };
            };

        };// end of Controller

        function indexSelections(market) {

            indexedMarketSelections[market.marketId] = [];

            market.selections.forEach(function (selection) {
                indexedMarketSelections[market.marketId].push(selection);
            });

        }
        function getMarketSelections(marketId) {
            return indexedMarketSelections[marketId];
        }
        this.getMarketSelections = function (marketId) {
            return getMarketSelections(marketId);
        };

        this.getPrice = function (selId) {
            if (prices[selId] !== undefined) {
                return prices[selId].item || { backPrices: [], layPrices: [] };
            } else {
                return { backPrices: [], layPrices: [] };
            }
        };

        this.getSportsbookPrice = function (selId) {
            return sportsbookPrices[selId];
        };
        this.getSelection = function (selId) {
            return selections[selId];
        };
        this.getMarket = function (marketId) {
            return markets[marketId];
        };
        var getState = function () {
            return {
                markets: markets,
                matchedAmounts: matchedAmounts,
                eventClassifiers: eventClassifiers,
                prices: prices,
                selections: selections
            };
        };
        this.getState = getState;

        function GBESelection(params, displayOrder, market) {
            var thisObject = this;

            Object.keys(params).forEach(function (key) {
                switch (key) {
                    case "selectionName":
                        thisObject["name"] = params[key];
                        break;

                    case "selectionStatus":
                        thisObject["status"] = params[key];
                        break;

                    default:
                        thisObject[key] = params[key];
                }
            });

            if (displayOrder !== undefined) {
                thisObject["displayOrder"] = displayOrder;
            }

            if (market !== undefined) {
                thisObject["marketId"] = market.marketId;
            }
        }

        function GBEMarket(params, displayOrder) {
            var thisObject = this;

            Object.keys(params).forEach(function (key) {
                switch (key) {
                    case "marketName":
                        thisObject["name"] = params[key];
                        break;
                    case "marketDescription":
                        thisObject["description"] = params[key];
                        break;
                    case "marketStatusId":
                        thisObject["status"] = params[key];
                        break;
                    case "willBeInRunning":
                        thisObject["canBeInRunning"] = params[key];
                        break;
                    case "inRunningDelaySeconds":
                        thisObject["delayFactor"] = params[key];
                        break;
                    case "selections":
                        thisObject["numberOfSelections"] = params[key].length;
                        break;

                    default:
                        thisObject[key] = params[key];
                }
            });

            if (displayOrder !== undefined) {
                thisObject["displayOrder"] = displayOrder;
            }

        }

    };

}// end of subscriptionManager

export default SubscriptionManagerV3IAPI;